import { combineReducers } from "redux";

import fetching from "./_fetching";
import Reasons from "./Reasons";

export default combineReducers({ fetching, Reasons });
